"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SkeletonImage = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    rounded,
    imgHeight,
    size,
    sizeIndex,
    // Size automatically from image height, unless any size prop is passed in
    sizePixels = !(size || sizeIndex) ? imgHeight : undefined,
    show,
    children
  } = _ref;
  if (!show) {
    return children;
  }
  const shape = rounded !== 'circle' ? 'box' : rounded;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Skeleton, {
    size: size,
    sizePixels: sizePixels,
    sizeIndex: sizeIndex,
    shape: shape,
    ref: ref
  });
});
SkeletonImage.displayName = 'SkeletonImage';
SkeletonImage.propTypes = {
  imgHeight: _propTypes.default.number,
  rounded: _propTypes.default.oneOf(['circle', 'corners']),
  size: _componentsBase.Skeleton.propTypes?.size,
  sizeIndex: _componentsBase.Skeleton.propTypes?.sizeIndex,
  sizePixels: _componentsBase.Skeleton.propTypes?.sizePixels,
  show: _propTypes.default.bool.isRequired,
  children: _propTypes.default.node
};
var _default = exports.default = SkeletonImage;